import PropTypes from 'prop-types'
import dayjs from 'dayjs'

export const getByWeekDayClass = (props) => {
  const {
    date, // e.g. 11-11-2011
    freqDaysInWeek, // e.g. ['Mon', 'Tues']
    freqInterval, // e.g. 2
    freqUnit, // e.g. 'week'
    medStartDate, // e.g. 01-11-2011
  } = props

  const difference = dayjs(date, 'DD-MM-YYYY')
    .startOf('day')
    .diff(
      dayjs(medStartDate, 'DD-MM-YYYY').startOf('day'),
      `${freqUnit}s`,
      true
    )

  const remainder = difference % freqInterval

  return remainder >= 0 && remainder < 1
    ? freqDaysInWeek.includes(dayjs(date, 'DD-MM-YYYY').format('ddd'))
      ? 'white'
      : 'grey'
    : 'grey'
}

getByWeekDayClass.propTypes = {
  date: PropTypes.string.isRequired,
  freqDaysInWeek: PropTypes.array.isRequired,
  freqInterval: PropTypes.string.isRequired,
  freqUnit: PropTypes.string.isRequired,
  medStartDate: PropTypes.string.isRequired,
}

export const checkExpectedRoundDates = (props) => {
  const {
    row: { freqDaysInWeek, freqInterval, freqUnit, medStartDate, medEndDate },
    value: { date },
  } = props

  const datedayjs = dayjs(date, 'DD-MM-YYYY')
  const medStartDatedayjs = dayjs(medStartDate, 'DD-MM-YYYY')
  const medEndDatedayjs = dayjs(medEndDate, 'DD-MM-YYYY')

  // Checks whether cell date is before the med start date
  // or after the med end date
  if (
    datedayjs.isBefore(medStartDatedayjs.startOf('day')) ||
    datedayjs.isAfter(medEndDatedayjs.endOf('day'))
  ) {
    return 'grey'
  }

  // Handles weekday repeats, e.g. Mon and
  // Wed, every two weeks
  if (freqDaysInWeek && freqDaysInWeek.length) {
    return getByWeekDayClass({ ...props.row, ...props.value })
  }

  const difference = datedayjs.diff(
    medStartDatedayjs.startOf('day'),
    `${freqUnit}s`,
    true
  )

  if (difference % freqInterval) return 'grey'

  return 'white'
}

/**
@description Gets the class for the cell. Returns grey/white,
or null if no value is passed in.

@param {object} value. The cell value. Contains info about that
specific day. E.g. {
    date: '03-10-2021',
    taken: true,
}

@param {object} row. The row object. Contains important data
for calculating whether a medication should be administered
on a given day.

E.g. {
    freqDaysInWeek: ['Mon', 'Wed'],
    freqInterval: 2,
    freqUnit: 'week'
    medStartDate: '01-01-2021',
    medEndDate: '01-01-2022',
    PRN: false
}

@returns {object} The hour column object.
*/

export const getCellClass = (props) => {
  const {
    row: { PRN },
    value,
  } = props

  if (!value) return null

  if (value && value.taken === false) {
    return 'white'
  } else if (value && value.taken === true) {
    return 'grey'
  } else if (PRN) {
    return 'grey'
  }

  const cellClass = checkExpectedRoundDates(props)

  return cellClass
}

getCellClass.propTypes = {
  row: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
}
